
import ScrollReveal from "scrollreveal";

document.addEventListener('DOMContentLoaded', function() {
    var sr = ScrollReveal();
    sr.reveal('.reveal', {
        delay: 100,
        interval: 100,
        reset: true
    });

    var sr2 = ScrollReveal();
    sr2.reveal('.revealup', {
        delay: 0,
        distance: '10%',
        origin: 'bottom',
        interval: 100,
        scale: 1.2,
    });
});